import React from 'react';
import { PropTypes } from 'prop-types';

const HospitalIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25281 3.46803C6.81726 -0.355162 11.5959 -1.12882 14.649 1.70504C17.702 4.5389 17.8643 12.3602 14.649 15.8089C11.4337 19.2576 4.023 18.1512 1.49955 15.8089C-1.0239 13.4667 -0.311651 7.29121 3.25281 3.46803Z"
      // eslint-disable-next-line react/destructuring-assignment
      fill={props.color}
      {...props}
    />
    <path
      d="M8.1 11.8618L8.89583 11.066L9.69167 11.8618C9.8125 11.9827 10.0125 11.9827 10.1333 11.8618C10.2542 11.741 10.2542 11.541 10.1333 11.4202L9.3375 10.6243L10.1333 9.82852C10.2542 9.70768 10.2542 9.50768 10.1333 9.38685C10.0745 9.32873 9.99518 9.29614 9.9125 9.29614C9.82982 9.29614 9.75047 9.32873 9.69167 9.38685L8.89583 10.1827L8.1 9.38685C8.04119 9.32873 7.96185 9.29614 7.87917 9.29614C7.79649 9.29614 7.71714 9.32873 7.65833 9.38685C7.5375 9.50768 7.5375 9.70768 7.65833 9.82852L8.45417 10.6243L7.65833 11.4202C7.5375 11.541 7.5375 11.741 7.65833 11.8618C7.77917 11.9827 7.97917 11.9827 8.1 11.8618ZM11.9167 6.24935H11.5V5.83268C11.5 5.60352 11.3125 5.41602 11.0833 5.41602C10.8542 5.41602 10.6667 5.60352 10.6667 5.83268V6.24935H7.33333V5.83268C7.33333 5.60352 7.14583 5.41602 6.91667 5.41602C6.6875 5.41602 6.5 5.60352 6.5 5.83268V6.24935H6.08333C5.62083 6.24935 5.25417 6.62435 5.25417 7.08268L5.25 12.916C5.25 13.137 5.3378 13.349 5.49408 13.5053C5.65036 13.6616 5.86232 13.7493 6.08333 13.7493H11.9167C12.375 13.7493 12.75 13.3743 12.75 12.916V7.08268C12.75 6.62435 12.375 6.24935 11.9167 6.24935ZM11.5 12.916H6.5C6.27083 12.916 6.08333 12.7285 6.08333 12.4993V8.33268H11.9167V12.4993C11.9167 12.7285 11.7292 12.916 11.5 12.916Z"
      fill="white"
    />
  </svg>
);

HospitalIcon.propTypes = {
  color: PropTypes.string,
};

HospitalIcon.defaultProps = {
  color: '#FB9318',
};

export default HospitalIcon;
